<style scoped>
    .group-container{
        min-height: 40px;
        border: 1px solid #dddee1;
        padding: 10px;
    }
    .group{
        display: inline-block;
        padding: 5px;
        margin-right: 5px;
        border: 1px solid #dddee1;
    }
</style>
<template>
  <Drawer
    v-model="config.modal"
    width="70"
  >
    <Spin
      v-if="loading"
      fix
    />
    <div v-if="customer.id">
      <div class="line">
        <h2>基本信息</h2>
        <Table
          border
          stripe
          :columns="base_info_columns"
          :data="customer_data"
          size="small"
        />
      </div>
      <br>
      <div class="line">
        <h2>入离职/合同信息</h2>
        <CustomerExpand :customer="customer" />
      </div>
      <br>
      <div class="line">
        <h2>组织信息</h2>
        <Table
          border
          stripe
          :columns="organization_columns"
          :data="organization_data"
          size="small"
        />
      </div>
      <br>
      <div class="line">
        <h2>所属群组</h2>
        <div class="group-container">
          <div
            v-for="group in groups"
            :key="group.title"
            class="group"
          >
            <span>{{ group.title }}</span> -
            <span>{{ group.name }}</span>
          </div>
          <span v-if="!groups.length">暂无</span>
        </div>
      </div>
      <br>
      <div class="line">
        <h2>
          登录验证信息
          <Poptip
            v-show="!auth_extra.secret_code"
            confirm
            title="确认生成？"
            @on-ok="genAuthExtra"
          >
            <Button
              size="small"
              type="primary"
            >
              生成登录认证信息
            </Button>
          </Poptip>
        </h2>
        <Table
          border
          stripe
          :columns="auth_columns"
          :data="auth_data"
          size="small"
        />
      </div>
      <br>
      <div class="line">
        <h2>
          <span>秘钥二维码 </span>
        </h2>
        <div v-if="auth_extra.secret_code && is_qr_exist">
          <qrcode
            :value="auth_extra.secret_url"
            :size="250"
          />
        </div>
        <div
          v-else
          class="info-disabled"
        >
          <span v-if="!auth_extra.secret_code">没有登录认证信息</span>
          <span v-if="!customer.email"> 未设置登录[邮箱]</span>
        </div>
      </div>
    </div>
  </Drawer>
</template>
<script :route="{path: '/hr/customer_detail/:id', noChkout: true}">
  import Util from '../../libs/util';
  import CustomerExpand from './components/customer_expand';
  export default {
    components: { CustomerExpand },
    data() {
      return {
        loading: false,
        customer: {careers: []},
        auth_extra: {},
        groups: [],
        config: {
          modal: false
        },
        base_info_columns: [
          {
            title: '姓名',
            key: 'account',
            //width: 80,
          },
          {
            title: '工号',
            key: 'uid',
            //width: 100
          },
          {
            title: '性别',
            key: 'gender',
            //width: 80,
            render: (h, params) => {
              const gender = params.row.gender ? '男' : '女';
              return h('span', gender);
            }
          },
          {
            title: '邮箱',
            key: 'email',
            //width: 180
          },
          {
            title: '手机',
            key: 'mobile',
            //width: 120
          },
          {
            title: '身份证',
            key: 'id_number',
          },
          {
            title: '账号创建日期',
            key: 'created_at',
            render: (h, params) => {
              return h('span', Util.formatDate(params.row.created_at));
            }
          }
        ],
        organization_columns: [
          {
            title: '公司',
            key: 'company',
          },
          {
            title: '团队',
            key: 'team',
          },
          {
            title: '岗位',
            key: 'job',
          },
        ],
        auth_columns: [
          {
            title: '认证方式',
            key: 'auth_type',
          },
          {
            title: '认证秘钥',
            key: 'secret_code',
            width: 160
          },
          /*{
                        title: '紧急密码',
                        key: 'scratch_codes',
                    },
                    {
                        title: '尝试限制',
                        key: 'rate_limit',
                    },*/
          {
            title: '时间偏差',
            key: 'time_skew',
          },
          {
            title: '最近更新',
            key: 'updated_at',
            render: (h, params) => {
              return <span>{ this.$util.formatTime(params.row.updated_at) }</span>
            }
          },
        ]
      }
    },
    computed: {
      customer_data() {
        return [this.customer]
      },
      organization_data() {
        return [this.customer]
      },
      auth_data() {
        return [this.auth_extra]
      },
      is_qr_exist() {
        return this.auth_extra.secret_url;
      },
      qr_config() {
        const url = this.auth_extra.secret_url;
        const value = url ? url : 'http://www.baicizhan.com';
        return {
          value: value,
          imagePath: '/src/image/logo.png',
          filter: 'threshold',
          background: '#ffffff',
          size: 250,
          fillType: 'fill',
          version: 20
        }
      }
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      show(customer_id) {
        this.config.modal = true;
        this.getInfo(customer_id);
      },
      getInfo(customer_id) {
        this.loading = true;
        this.$util.ajax.get(this.$util.api.customer_detail, {
          params: {
            id: customer_id
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.handleData(data);
          } else {
            this.$Modal.error({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          console.log(e);
        }).finally(() => {
          this.loading = false;
        });
      },
      handleData(data) {
        this.customer = data.customer;
        if (data.auth_extra) {
          this.auth_extra = data.auth_extra;
        } else {
          this.auth_extra = {};
        }
        this.groups = [];
        data.groups.forEach((group) => {
          this.groups.push(group);
        });
      },
      genAuthExtra() {
        Util.ajax.post(Util.api.generate_auth_extra, {
          customer_id: this.customer.id
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.handleData(data);
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      }
    }
  }
</script>
